// Path: ./src/utils/banner/bannerRow.ts
import {
  CreateGfBannerDto,
  GfBanner,
  GfImage,
  GfMerchant,
} from "@swagger/typescript-fetch-goflyer";

export type BannerRow = GfBanner & {
  desktopImage?: GfImage;
  mobileImage?: GfImage;
};

export const resolveMerchantId = (
  merchantId?: GfMerchant | string,
): string | undefined => {
  if (!merchantId) return undefined;
  if (typeof merchantId === "string") return merchantId;
  return merchantId.id;
};

export const toBannerDate = (value?: Date | string): Date | undefined => {
  if (!value) return undefined;
  const parsed = value instanceof Date ? value : new Date(value);
  return Number.isNaN(parsed.getTime()) ? undefined : parsed;
};

export const bannerToFormState = (banner: BannerRow): CreateGfBannerDto => {
  const {
    id: _id,
    createdAt: _createdAt,
    updatedAt: _updatedAt,
    isDeleted: _isDeleted,
    createdByAdminId: _createdByAdminId,
    createdByAdmin: _createdByAdmin,
    updatedByAdminId: _updatedByAdminId,
    updatedByAdmin: _updatedByAdmin,
    desktopImage: _desktopImage,
    mobileImage: _mobileImage,
    merchantId,
    ...rest
  } = banner;

  return {
    ...rest,
    merchantId: resolveMerchantId(merchantId),
  } as CreateGfBannerDto;
};
